/* __next_internal_client_entry_do_not_use__ ClearWrapper,ClearButton,Label,Pill auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Typography, TypographyStyles } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";
import { Close } from "../icons/deprecated/Close";
import { themeOrDefault } from "../Theme";
import { responsiveMediaQueries } from "../Theme/responsiveMediaQueries";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
/* eslint-disable @faire/enforce-no-supersededby-components */ export var ClearWrapper = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-976d9f85-0"
})([
    "width:26px;height:26px;border-radius:50%;"
]);
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/IconButton/IconButton#IconButton"
 */ export var ClearButton = function(props) {
    var handleClick = function(event) {
        event.stopPropagation();
        event.preventDefault();
        props.onClick();
    };
    return /*#__PURE__*/ _jsx(ClearWrapper, {
        onClick: handleClick,
        "data-test-id": props["data-test-id"],
        children: /*#__PURE__*/ _jsx(Close, {
            fontSize: "10px",
            strokeWidth: 1
        })
    });
};
export var Label = styled(Typography).attrs({
    color: "inherit"
}).withConfig({
    componentId: "sc-976d9f85-1"
})([
    "&&&{",
    ";color:inherit;}"
], function(param) {
    var theme = param.theme;
    var _theme_pills_filter, _theme_pills;
    var _theme_pills_filter_label;
    return TypographyStyles((_theme_pills_filter_label = (_theme_pills = theme.pills) === null || _theme_pills === void 0 ? void 0 : (_theme_pills_filter = _theme_pills.filter) === null || _theme_pills_filter === void 0 ? void 0 : _theme_pills_filter.label) !== null && _theme_pills_filter_label !== void 0 ? _theme_pills_filter_label : {});
});
export var Pill = function(_param) {
    var isOpen = _param.isOpen, hasFilterSelected = _param.hasFilterSelected, displayCloseButton = _param.displayCloseButton, alwaysShowCloseButton = _param.alwaysShowCloseButton, as = _param.as, ref = _param.ref, rest = _object_without_properties(_param, [
        "isOpen",
        "hasFilterSelected",
        "displayCloseButton",
        "alwaysShowCloseButton",
        "as",
        "ref"
    ]);
    return /*#__PURE__*/ _jsx(BasePill, _object_spread_props(_object_spread({
        ref: ref,
        forwardedAs: as
    }, rest), {
        $isOpen: isOpen,
        $hasFilterSelected: hasFilterSelected,
        $displayCloseButton: displayCloseButton,
        $alwaysShowCloseButton: alwaysShowCloseButton
    }));
};
var BasePill = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-976d9f85-2"
})([
    "border-radius:20px;cursor:pointer;padding:",
    ";height:40px;",
    "{&:hover{background-color:",
    ";}}",
    ";",
    " &:focus-visible{outline:2px solid -webkit-focus-ring-color;}"
], function(props) {
    return !props.$displayCloseButton ? "8px 16px" : "8px 8px 8px 16px";
}, ClearWrapper, function(param) {
    var theme = param.theme, alwaysShowCloseButton = param.$alwaysShowCloseButton, hasFilterSelected = param.$hasFilterSelected;
    return alwaysShowCloseButton && !hasFilterSelected ? theme.pills.filter.secondary.color : theme.pills.filter.primary.color;
}, function(props) {
    var theme = themeOrDefault(props.theme);
    var _theme_pills = theme.pills, _theme_pills_filter = _theme_pills.filter, primary = _theme_pills_filter.primary, secondary = _theme_pills_filter.secondary;
    var _secondary_color;
    var regular = (_secondary_color = secondary.color) !== null && _secondary_color !== void 0 ? _secondary_color : Core.surface.muted;
    var _secondary_hover;
    var regularHover = (_secondary_hover = secondary.hover) !== null && _secondary_hover !== void 0 ? _secondary_hover : Core.surface.subdued;
    var _secondary_contrast;
    var regularLetter = (_secondary_contrast = secondary.contrast) !== null && _secondary_contrast !== void 0 ? _secondary_contrast : Core.text.default;
    var _primary_color;
    var active = (_primary_color = primary.color) !== null && _primary_color !== void 0 ? _primary_color : Core.surface.default;
    var _primary_hover;
    var activeHover = (_primary_hover = primary.hover) !== null && _primary_hover !== void 0 ? _primary_hover : Core.surface.hover;
    var _primary_contrast;
    var activeLetter = (_primary_contrast = primary.contrast) !== null && _primary_contrast !== void 0 ? _primary_contrast : Core.text.inverse;
    var styles;
    if (props.$hasFilterSelected) {
        styles = css([
            "&:hover{background-color:",
            ";}"
        ], activeHover);
    } else if (props.$isOpen) {
        styles = css([
            "background-color:",
            ";color:",
            ";&:hover{background-color:",
            ";}"
        ], active, activeLetter, activeHover);
    } else {
        styles = css([
            "&:hover{background-color:",
            ";}"
        ], regularHover);
    }
    return css([
        "background-color:",
        ";color:",
        ";",
        "{",
        "}"
    ], props.$hasFilterSelected ? active : regular, props.$hasFilterSelected ? activeLetter : regularLetter, responsiveMediaQueries.desktopAndAbove, styles);
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
Pill.displayName = "Filter";
